import type { SymbolDefinition } from "../types.ts";

export const pushButton: SymbolDefinition = {
  id: "ep-push-button",
  familyKey: "push_button",
  deviceKind: "push_button",
  version: "0.1.0",
  label: { sv: "Tryckknapp", en: "Push button" },
  description: { sv: "Momentant slutande tryckknapp.", en: "Momentary normally-open push button." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="6" y1="10" x2="18" y2="10"/>
      <line x1="12" y1="8" x2="12" y2="10"/>
      <line x1="12" y1="14" x2="12" y2="22"/>
      <line x1="7" y1="14" x2="17" y2="14"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "control", label: "13", position: "top", offset: 0.5 },
    { id: "out", kind: "control", label: "14", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "S",
  searchKeywords: ["tryckknapp", "push button", "knapp"],
};
